export default __webpack_public_path__ + "static/media/howtouse_img_01.e50630b2.svg";